import { useGateValue, useStatsigClient } from '@statsig/react-bindings';
import { TRACKING_PURCHASES_ENABLED } from 'src/types/FeataureFlags';

interface CanPurchaseTrackingState {
  canPurchaseTracking: boolean;
  isLoading: boolean;
}

const useCanPurchaseTracking = (): CanPurchaseTrackingState => {
  const canPurchaseTracking = useGateValue(TRACKING_PURCHASES_ENABLED);
  const { isLoading } = useStatsigClient();

  return { canPurchaseTracking, isLoading };
};

export default useCanPurchaseTracking;
